import * as fromRouter from '@ngrx/router-store';
import { combineReducers, ActionReducerMap, ActionReducer, MetaReducer, createReducer } from '@ngrx/store';

import * as fromNgCore from '@opm/ng-core';
import { InjectionToken } from '@angular/core';
import { environment } from 'src/environments/environment';
import { EntityState } from '@ngrx/entity';
import { BUProfile } from 'shared/models/buProfile';
import { RootSelectors } from './app.selectors'
import { BargainingUnitProfileEntity } from './entities/bargaining-unit-profile-entity';
import { Lookups } from './lookup-state'

export { RootSelectors };

export interface BargainingUnitProfileEntityState extends EntityState<BUProfile> { }

export interface EntitiesState {
    profiles: BargainingUnitProfileEntityState;
}


export const entitiesReducer = combineReducers<EntitiesState>({
    profiles: BargainingUnitProfileEntity.reducer
});

export interface RootState {
    shell: fromNgCore.ShellState;
    routes: fromRouter.RouterReducerState<fromNgCore.RouterStateUrl>;
    entities: EntitiesState;
	lookups: Lookups.LookupState;
}

export interface State {
    root: RootState
}

export const reducers = combineReducers({
    shell: fromNgCore.reducer,
    routes: fromRouter.routerReducer,
    entities: entitiesReducer,
	lookups: Lookups.reducer
});

export const reducerToken = new InjectionToken<ActionReducerMap<State>>('Reducers');

export function getReducers() {
    return { root: reducers };
}

export const reducerProvider = [
    { provide: reducerToken, useFactory: getReducers }
];

export function logger(reducer: ActionReducer<State>): ActionReducer<State> {
    return (state: State, action: any): any => {
        const result = reducer(state, action);
        console.groupCollapsed(action.type);
        console.log('prev state', state);
        console.log('action', action);
        console.log('next state', result);
        console.groupEnd();

        return result;
    };
}

export const metaReducers: MetaReducer<State>[] = !environment.production ? [] : [];
